import React from 'react';
import { FormGroup } from 'reactstrap';
import { faCalendarTimes } from '@fortawesome/free-solid-svg-icons';
import { BaseFormViewModel } from '../common/ViewModel';
import {
    FormCheckbox,
    Input, NumericInput,
} from '../common/forms/FormElements';
import CommonContext from '../Common';
import SlideForm from '../common/forms/SlideForm';
import { handleFormSaveError } from '../common/forms/ValidationError';
import { CertificationViewModel } from './Certification';


export default class CertificationForm extends React.Component {
    static contextType = CommonContext;

    constructor(props) {
        super(props);
        this.formRef = React.createRef();

        this.state = {
            selectedCertification:
                props.selectedCertification ?? new CertificationViewModel(),
            ...new BaseFormViewModel(),
            loading: false,
        };

        this.onSubmit = this.onSubmit.bind(this);
        this.onClose = this.onClose.bind(this);
    }
    onClose = (response) => {
        this.resetForm();
        this.context.setFormOpened(false);
        this.props.onClose(response);
    };
    onSubmit = () => {
        this.clearErrors();
        this.props.onSaveCallback();
        this.resetForm();
    };

    clearErrors = () => this.setState({ errors: {} });
    handleSaveError = (err) => handleFormSaveError(this, err);
    resetForm = () => this.setState({ formValidated: false });

    render() {
        const { formValidated, validationMessage, loading } = this.state;
        const { selectedCertification: certification, show, onChange } = this.props;

        const selectedCertification = certification || {};

        return (
            <SlideForm
                loading={loading}
                show={show}
                id="certificationForm"
                formIcon={faCalendarTimes}
                formTitle={
                    selectedCertification.id
                        ? 'Edit Certification'
                        : 'Add Certification'
                }
                ref={this.formRef}
                setIsValidated={(value) => this.setState({ formValidated: value })}
                isValidated={formValidated}
                removeUnavailable
                onSubmit={this.onSubmit}
                onClose={this.onClose}
                errors={this.state.errors}
                onClearErrors={this.clearErrors}
                error={validationMessage}
                entityId={selectedCertification.id}
            >

                <Input
                    label="Name"
                    id="name"
                    name="selectedCertification.name"
                    value={selectedCertification.name || ''}
                    onChange={onChange}
                    placeholder="Enter Name"
                    maxLength={250}
                    error="Name is required."
                    required
                />
                <Input
                    label="Abbreviation"
                    id="abbreviation"
                    name="selectedCertification.abbreviation"
                    value={selectedCertification.abbreviation || ''}
                    onChange={onChange}
                    placeholder="Enter the Abbreviation for Certification"
                    maxLength={6}
                    error="Abbreviation is required"
                    required
                />
                {!!this.context.tenant.tenantSettings
                    ?.enablePayIncentivesforCertifications && (
                        <NumericInput
                            label="Incentive Amount"
                            id="incentiveAmount"
                            name="selectedCertification.incentiveAmount"
                            value={selectedCertification.incentiveAmount ?? {}}
                            onChange={onChange}
                            placeholder="Enter Incentive Amount (in dollars)"
                            step={0.01}
                            startAddon={(
                                <span className="text-muted">$</span>
                            )}
                        />
                    )}
                <FormGroup>
                    <FormCheckbox
                        id="proofRequired"
                        name="selectedCertification.proofRequired"
                        checked={!!selectedCertification.proofRequired}
                        onChange={onChange}
                        labelText="Requires Proof"
                    />
                </FormGroup>

                <FormGroup>
                    <FormCheckbox
                        id="willExpire"
                        name="selectedCertification.willExpire"
                        checked={!!selectedCertification.willExpire}
                        onChange={onChange}
                        labelText="Expires"
                    />
                </FormGroup>
                <FormGroup>
                    <FormCheckbox
                        id="showOnDispatchBoard"
                        name="selectedCertification.showOnDispatchBoard"
                        checked={!!selectedCertification.showOnDispatchBoard}
                        onChange={onChange}
                        labelText="Show Certification on Dispatch Board"
                    />
                </FormGroup>
                <FormGroup>
                    <FormCheckbox
                        id="mustBeValidForDispatch"
                        name="selectedCertification.mustBeValidForDispatch"
                        checked={!!selectedCertification.mustBeValidForDispatch}
                        onChange={onChange}
                        labelText="This certification must be valid for employees to be dispatched"
                    />
                </FormGroup>
                <FormGroup>
                    <FormCheckbox
                        id="isOperatorLevel"
                        name="selectedCertification.isOperatorLevel"
                        checked={!!selectedCertification.isOperatorLevel}
                        onChange={onChange}
                        labelText="Is an Operator Level"
                    />
                </FormGroup>
                {!!selectedCertification.isOperatorLevel && (
                    <FormGroup>
                        <FormCheckbox
                            id="isGSFOperatorLevel"
                            name="selectedCertification.isGSFOperatorLevel"
                            checked={!!selectedCertification.isGSFOperatorLevel}
                            onChange={onChange}
                            labelText="Requires GSF Assigned"
                        />
                    </FormGroup>
                )}
                <FormGroup>
                    <FormCheckbox
                        id="showOnDispatchPlusHandoffEmail"
                        name="selectedCertification.showOnDispatchPlusHandoffEmail"
                        checked={!!selectedCertification.showOnDispatchPlusHandoffEmail}
                        onChange={onChange}
                        labelText="Include on Dispatch+"
                    />
                </FormGroup>
                <FormGroup>
                    <FormCheckbox
                        id="isActive"
                        name="selectedCertification.isActive"
                        checked={!!selectedCertification.isActive}
                        onChange={onChange}
                        labelText="Active"
                    />
                </FormGroup>

            </SlideForm>
        );
    }
}
